(function () {
  'use strict';

  function initReveal() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mt-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    els.forEach(function (el, i) {
      el.style.setProperty('--mt-order', el.dataset.mtOrder || i % 6);
      observer.observe(el);
    });
  }

  function initComparadores() {
    var wraps = document.querySelectorAll('[data-mt-comparador]');
    wraps.forEach(function (wrap) {
      var antes = wrap.querySelector('.mt-comparador__antes');
      var manija = wrap.querySelector('.mt-comparador__manija');
      var asa = wrap.querySelector('.mt-comparador__asa');
      if (!antes) return;

      var dragging = false;

      function setPosition(clientX) {
        var rect = wrap.getBoundingClientRect();
        var pct = ((clientX - rect.left) / rect.width) * 100;
        pct = Math.max(0, Math.min(100, pct));
        antes.style.clipPath = 'inset(0 ' + (100 - pct) + '% 0 0)';
        if (manija) manija.style.left = pct + '%';
        if (asa) asa.style.left = pct + '%';
      }

      function onMove(e) {
        if (!dragging) return;
        var x = e.touches ? e.touches[0].clientX : e.clientX;
        setPosition(x);
      }

      wrap.addEventListener('mousedown', function (e) { dragging = true; setPosition(e.clientX); });
      wrap.addEventListener('touchstart', function (e) { dragging = true; setPosition(e.touches[0].clientX); }, { passive: true });
      window.addEventListener('mouseup', function () { dragging = false; });
      window.addEventListener('touchend', function () { dragging = false; });
      window.addEventListener('mousemove', onMove);
      window.addEventListener('touchmove', onMove, { passive: true });
      wrap.addEventListener('click', function (e) { setPosition(e.clientX); });
    });
  }

  function initCountUp() {
    var items = document.querySelectorAll('[data-mt-countup]');
    if (!items.length || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          var target = parseFloat(el.dataset.mtCountup) || 0;
          var duration = 1200;
          var start = null;

          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var value = Math.floor(progress * target);
            el.textContent = value.toLocaleString('es-ES');
            if (progress < 1) requestAnimationFrame(step);
            else el.textContent = target.toLocaleString('es-ES');
          }
          requestAnimationFrame(step);
          observer.unobserve(el);
        });
      },
      { threshold: 0.4 }
    );

    items.forEach(function (el) { observer.observe(el); });
  }

  function initGaleriaPorColor() {
    var radios = document.querySelectorAll('.product-form__input input[type="radio"]');
    if (!radios.length) return;

    var mediaItems = document.querySelectorAll('.product__media-item');
    if (!mediaItems.length) return;

    var groups = {};
    radios.forEach(function (r) {
      var name = r.name.trim();
      (groups[name] = groups[name] || []).push(r);
    });

    function altOf(li) {
      var img = li.querySelector('img');
      return img ? (img.alt || '').toLowerCase() : '';
    }

    var modalImgs = document.querySelectorAll('product-modal img[data-media-id], .product-media-modal img[data-media-id]');

    Object.keys(groups).forEach(function (name) {
      var group = groups[name];
      var values = group.map(function (r) { return r.value.trim().toLowerCase(); });

      var isColorTagged = values.every(function (v) {
        return [].some.call(mediaItems, function (li) {
          return altOf(li).indexOf('en ' + v) !== -1;
        });
      });
      if (!isColorTagged) return;

      function applyFilter() {
        var selected = group.filter(function (r) { return r.checked; })[0];
        if (!selected) return;
        var value = selected.value.trim().toLowerCase();
        var hiddenIds = {};

        mediaItems.forEach(function (li) {
          var alt = altOf(li);
          var matchesAnyColor = values.some(function (v) { return alt.indexOf('en ' + v) !== -1; });
          var visible = !matchesAnyColor || alt.indexOf('en ' + value) !== -1;
          li.classList.toggle('mt-color-hidden', !visible);
          if (!visible) hiddenIds[li.dataset.mediaId] = true;
        });

        document.querySelectorAll('.thumbnail-list__item').forEach(function (thumb) {
          var target = thumb.dataset.target;
          thumb.classList.toggle('mt-color-hidden', !!hiddenIds[target]);
        });

        modalImgs.forEach(function (img) {
          var alt = (img.alt || '').toLowerCase();
          var matchesAnyColor = values.some(function (v) { return alt.indexOf('en ' + v) !== -1; });
          var visible = !matchesAnyColor || alt.indexOf('en ' + value) !== -1;
          img.classList.toggle('mt-color-hidden', !visible);
        });
      }

      group.forEach(function (r) { r.addEventListener('change', applyFilter); });
      applyFilter();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initComparadores();
    initCountUp();
    initGaleriaPorColor();
  });
})();
